// eslint-disable-next-line no-restricted-imports
import { Card, CardContent, Skeleton, Stack } from "@mui/material";

export function BreakPaymentRequestsLoadingPageState() {
  return (
    <Stack spacing={6} aria-label="Loading break payment requests">
      {Array.from({ length: 3 }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Card key={index}>
          <CardContent sx={{ padding: 6 }}>
            <Stack spacing={6}>
              <Stack direction="row" spacing={2}>
                <Skeleton variant="rounded" width={140} height={24} />
              </Stack>

              <Stack direction="row" spacing={5}>
                <Skeleton variant="circular" width={40} height={40} />
                <Stack spacing={3} flexGrow={1}>
                  <Stack spacing={2}>
                    <Skeleton variant="text" width={120} />
                    <Skeleton variant="text" width={180} />
                  </Stack>
                  <Stack spacing={1}>
                    <Skeleton variant="text" width="60%" />
                    <Skeleton variant="text" width="40%" />
                    <Skeleton variant="text" width="50%" />
                  </Stack>
                </Stack>
              </Stack>

              <Skeleton variant="text" sx={{ width: "100%" }} />

              <Stack spacing={4}>
                <Skeleton variant="text" width={200} />
                <Skeleton variant="text" width={300} />
                <Skeleton variant="rectangular" height={36} sx={{ mt: 4 }} />
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}
